import { Injectable } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { ZendeskProvider } from '../provider/zendesk.provider';
import { SessionService } from '@monsido/core/session/session.service';
import { EventsType } from '@monsido/services/mon-event/events.type';

@Injectable({
    providedIn: 'root',
})
export class ZendeskRunService {
    constructor (
        private monEventService: MonEventService,
        private zendeskProvider: ZendeskProvider,
        private sessionService: SessionService,
    ) {}

    public setupEventListeners (): void {
        this.monEventService.addListener('afterCustomer' as EventsType, () => {
            if (this.sessionService.getChatSystem() === 'zendesk' && !this.sessionService.isSudo) {
                this.zendeskProvider.addScript();
            }
        });
    }
}
